import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = {
    key: 0,
    class: "q-pb-lg"
};
const _hoisted_3 = { class: "text-h6 text-bold-red" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "row q-mx-md items-center" };
const _hoisted_6 = { class: "col" };
const _hoisted_7 = { class: "row items-center" };
const _hoisted_8 = {
    style: { "font-size": "14px" },
    class: "text-grey"
};
const _hoisted_9 = {
    key: 0,
    class: "q-ml-md"
};
const _hoisted_10 = { class: "row justify-between" };
const _hoisted_11 = { class: "q-pl-md" };
const _hoisted_12 = { class: "row justify-end" };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "row q-mx-md items-center" };
const _hoisted_16 = { class: "col" };
const _hoisted_17 = { class: "row items-center" };
const _hoisted_18 = {
    style: { "font-size": "14px" },
    class: "text-grey"
};
const _hoisted_19 = {
    key: 0,
    class: "q-ml-md"
};
const _hoisted_20 = { class: "q-ml-md" };
const _hoisted_21 = { class: "row justify-between" };
const _hoisted_22 = { class: "q-pl-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_mypage_badge = _resolveComponent("mypage-badge");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_btn = _resolveComponent("q-btn");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.list.nonresponseInformation.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_q_card, { class: "bg-alpha" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.nonresponseCount), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.nonresponseInformation, (info) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "info-row",
                                key: info.informationNo
                            }, [
                                _createElementVNode("div", {
                                    class: "q-pt-sm",
                                    onClick: ($event) => (_ctx.onRowClick(info.informationNo))
                                }, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("div", _hoisted_8, _toDisplayString(info.startAt), 1),
                                                (info.weight)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createVNode(_component_mypage_badge, {
                                                            style: 'line-height: 15px; width: 70px;',
                                                            kbn: _ctx.weightKbn,
                                                            id: _ctx.weightid
                                                        }, null, 8, ["kbn", "id"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("div", _hoisted_11, _toDisplayString(info.subject), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                (info.deadlineApproaching && info.responseDeadline)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        style: { "font-size": "14px" },
                                                        class: _normalizeClass(["text-grey", { 'q-pr-lg': !(_ctx.$q.screen.sm || _ctx.$q.screen.xs) }])
                                                    }, " 回答期限：" + _toDisplayString(info.responseDeadline), 3))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _createVNode(_component_q_icon, {
                                            name: "chevron_right",
                                            color: "grey",
                                            "aria-hidden": "true"
                                        })
                                    ]),
                                    _createVNode(_component_q_separator, { class: "q-mt-sm" })
                                ], 8, _hoisted_4)
                            ]));
                        }), 128))
                    ]),
                    _: 1
                })
            ]))
            : _createCommentVNode("", true),
        (_ctx.list.latestInformation.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_q_card, { class: "bg-alpha" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("div", { class: "text-h6 text-bold" }, "未確認のお知らせ", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.latestInformation, (info) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "info-row",
                                key: info.informationNo
                            }, [
                                _createElementVNode("div", {
                                    class: "q-pt-sm",
                                    onClick: ($event) => (_ctx.onRowClick(info.informationNo))
                                }, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, _toDisplayString(info.startAt), 1),
                                                (info.weight)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                        _createVNode(_component_mypage_badge, {
                                                            style: 'line-height: 15px; width: 70px;',
                                                            kbn: _ctx.weightKbn,
                                                            id: _ctx.weightid
                                                        }, null, 8, ["kbn", "id"])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createVNode(_component_mypage_badge, {
                                                        style: 'line-height: 15px; width: 70px;',
                                                        kbn: _ctx.readKbn,
                                                        id: _ctx.readId
                                                    }, null, 8, ["kbn", "id"])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, _toDisplayString(info.subject), 1)
                                            ])
                                        ]),
                                        _createVNode(_component_q_icon, {
                                            name: "chevron_right",
                                            color: "grey",
                                            "aria-hidden": "true"
                                        })
                                    ]),
                                    _createVNode(_component_q_separator, { class: "q-mt-sm" })
                                ], 8, _hoisted_14)
                            ]));
                        }), 128)),
                        _createVNode(_component_q_card_section, { class: "text-right" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: "すべて見る",
                                    color: "green-7",
                                    onClick: _ctx.onClick
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]))
            : _createCommentVNode("", true)
    ]));
}
